<template>
    <section class="login-now" loding="lazy">
        <div class="wrapper">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12">
                        <div class="loginInner1" v-if="$siteSettings?.data">
                            <div class="log-logo">
                                <img :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path.domain_image + $siteSettings?.data?.logo"
                                    alt="logo">
                            </div>
                            <div class="featured-box-login">
                                <!-- <h1>{{ $t('log-in','Login')}}<i class="fas fa-hand-point-down"></i></h1> -->
                                <form class="form-control-head">
                                    <div class="login-tab-sec">
                                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist" v-if="$siteSettings?.data?.business_type == 2">
                                            <li class="nav-item" role="presentation">
                                                <button class="nav-link" :class="form.type == 1 ? 'active': ''" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#phone-num" @click="chooseFormType('1')" type="button" role="tab"
                                                    aria-controls="phone-num" aria-selected="true">{{ $t('mobile-number',' Mobile Number')}}</button>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                                <button class="nav-link" :class="form.type == 2 ? 'active': ''" id="user-id-tab" data-bs-toggle="pill" data-bs-target="#user-id" type="button" role="tab"
                                                    aria-controls="user-id" aria-selected="false" @click="chooseFormType('2')">{{ $t('user-id','User ID')}}</button>
                                            </li>
                                        </ul>
                                        <div class="tab-content" id="pills-tabContent" v-if="$siteSettings?.data?.business_type == 2">

                                            <div class="tab-pane fade" :class="form.type == 1 ? 'show active': ''" id="phone-num" role="tabpanel" aria-labelledby="phone-num-tab">
                                                <div class="mobile-input-h">
                                                </div>
                                                <div class="form-group">
                                                    <div class="get-mob">
                                                        <div class="row">
                                                            <div class="col-2">
                                                                <div class="col-auto login_cl_mast">
                                                                    <select v-model="form.code" class="form-select" aria-label="Default select example" :disabled="timerRunning">
                                                                        <option :value="allowedCountry.phonecode"
                                                                            v-for="(allowedCountry, countryIndex) in $siteSettings?.data?.country_code_list"
                                                                            :key="countryIndex">+{{ allowedCountry.phonecode }}
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div class="col-10">
                                                                <div class="col-auto login_cl_mast2">
                                                                    <input type="tel" class="form-control add"
                                                                        id="autoSizingInput" :placeholder="$t('mobile-number','Enter Mobile Number')+'*'" :disabled="resendOtp && timerRunning" required maxlength="10"
                                                                        v-model="form.mobileNo" @input="form.mobileNo = $helper.sanitizeNumber(form.mobileNo, 9999999999);" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="error-message-box" v-if="init && checkValidation?.mobile?.length > 0">
                                                        <p class="wrong-message" v-for="(err, index) in checkValidation?.mobile" :key="index">
                                                        {{ $t(err.lang, err.error) }}</p> 
                                                    </div>
                                                </div>
                                                <div class="error-message-box" v-if="init && form.mobileNo.length == 10 && !timerRunning && loginMethod == 'otp'">
                                                    <p class="wrong-message">{{$t('please-click-on-send-otp','Please Click on Send OTP')}}</p>
                                                </div> 
                                                <div class="d-flex login-method-section mt-3">
                                                    <div class="label-tabs">
                                                        <input class="form-check-input flexRadioDefault-sec" type="radio" name="login-method" id="login-password" value="password" v-model="loginMethod" @click="form.password =''">
                                                        <label for="login-password">{{$t('password','Password')}}</label>
                                                    </div>
                                                    <div class="label-tabs">
                                                        <input class="form-check-input flexRadioDefault-sec" type="radio" name="login-method" id="login-otp" value="otp" v-model="loginMethod" @click="form.password =''">
                                                        <label for="login-otp">{{$t('otp','OTP')}}</label>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="tab-pane fade" :class="form.type == 2 ? 'show active': ''" id="user-id" role="tabpanel" aria-labelledby="user-id-tab">
                                                <div class="mobile-input-h">
                                                </div>
                                            <div class="form-group">
                                                    <div class="user-password-wrapper">
                                                        <div class="password-box get-mob for">
                                                            <input type="text" class="form-control" @input="form.userId = $helper.sanitizeDetails('login', form.userId);"
                                                            :placeholder="$t('user-id','User ID')+''" v-model="form.userId" id="autoSizingInput" >
                                                            <div class="inp-img">
                                                                <img src="@/assets/images/user-login.webp" alt="" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="init && checkValidation?.userId?.length > 0" class="error-message-box mt-2">
                                                        <span v-for="(err, index) in checkValidation?.userId" :key="index">
                                                            <p class="wrong-message">{{ $t(err.lang, err.error) }}</p>
                                                        </span>                                                
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="tab-content" id="pills-tabContent" v-else>
                                            <div class="tab-pane fade show active" id="user-id" role="tabpanel" aria-labelledby="user-id-tab">
                                                <div class="mobile-input-h">
                                                    <!-- <label for="">User ID</label> -->
                                                </div>
                                                <div class="form-group">
                                                    <div class="user-password-wrapper">
                                                        <div class="password-box get-mob for">
                                                            <input type="text" class="form-control" @input="form.userId = $helper.sanitizeDetails('login', form.userId);"
                                                            :placeholder="$t('user-id','User ID')+''" v-model="form.userId">
                                                            <div class="inp-img">
                                                                <img src="@/assets/images/user-login-icons.webp" alt="" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="init && checkValidation?.userId?.length > 0" class="error-message-box mt-2">
                                                        <span v-for="(err, index) in checkValidation?.userId" :key="index">
                                                            <p class="wrong-message">{{ $t(err.lang, err.error) }}</p>
                                                        </span>                                                
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="form-container-sec">
                                            <div class="password-input-box">
                                                <div class="get-mob for eye-pass-visible">
                                                    <input :type="passwordFieldType" v-if="loginMethod == 'password'" v-model="form.password" :placeholder="$t('enter-pass', 'Enter Password' +'*')"
                                                        class="form-control" @input="form.password = $helper.sanitizeDetails('oldLoginPassword', form.password);">
                                                    <input v-model="form.password" class="form-control" id="myPassInput" type="text" v-if="loginMethod == 'otp'"
                                                        :placeholder="$t('enter-otp','Enter OTP')" aria-label="password" @input="form.password = $helper.sanitizeNumber(form.password,999999);"
                                                        aria-describedby="addon-wrapping" maxlength="6">
                                                    <div class="inp-img">
                                                        <!-- <img  rel="preload"  src="@/assets/images/lock_icon.svg" alt=""> -->
                                                    </div>
                                                    <div class="eye-icn-sec" @click="togglePasswordVisibility()" v-if="loginMethod == 'password'">
                                                        <img  rel="preload"  v-if="passwordFieldType === 'password'" src="@/assets/images/passwordhideicon.webp">
                                                        <img  rel="preload"  v-else src="@/assets/images/passwordviewicon.webp">
                                                    </div>
                                                    <span class="btn send-login-otp password-show-hide p-0" :class="{'btn-disabled' : isOtpApiCalled && (minutes > 0 || seconds > 0) }" v-if="loginMethod == 'otp'">
                                                        <button class="get-otp-btn" :disabled="isOtpApiCalled && (minutes > 0 || seconds > 0)" @click.prevent="sendOtpCall()">
                                                            {{ timerRunning ? formatTime(minutes) + ":" + formatTime(seconds) : resendOtp ? $t('resend-otp',"Resend OTP") : $t('get-otp',"Get OTP") }}
                                                        </button>
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-if="showValidationError && form.password == ''">
                                                <p class="wrong-message mt-1">
                                                    {{ $t(`please-enter-${loginMethod.toLowerCase()}`,`Please Enter ${loginMethod}.`)}}
                                                </p>
                                            </div>
                                            <div v-if="form.password.length > 0 && form.password.length < 6 && loginMethod == 'otp' && showValidationError">
                                                <p class="wrong-message mt-1">
                                                    {{ $t('otp-6-digit-msg','Please Enter 6 Digit OTP')}}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="check-box-sec">
                                        <!-- <div class="box-left">
                                            <div class="form-check">
                                                <input type="checkbox" class="form-check-input" id="check1" name="option1"
                                                    value="something">
                                                <label class="form-check-label" for="check1">{{ $t('keep-me-logged-in','Keep Me Logged In?') }}</label>
                                            </div>
                                        </div> -->
                                        <div class="box-right" v-if="$siteSettings?.data?.business_type == 2">
                                            <div class="for-pass">
                                                <router-link v-if="isRootUrl" @click="refreshData()" :to="{ name: 'ForgetPassword' }">
                                                    {{ $t('forgot-password','Forgot Password?') }}
                                                </router-link>
                                                <a v-else data-bs-toggle="modal" @click="refreshData()" data-bs-target="#forgotPasswordModal">
                                                    {{ $t('forgot-password','Forgot Password?') }}
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="login-btn-option">
                                        <div class="form-group">
                                            <a href="JAvascript:void(0);" @click="demoUserLogin()"
                                                class="btn btn-submit btn-login">
                                                <span>
                                                    {{ $t('demo-login','Login with Demo')}}
                                                    <i class="ml-2 fas fa-sign-in-alt"></i>
                                                </span>
                                                <span v-if="demoloading"> 
                                                    <span class="load-inner"><i class="fa fa-spinner fa-spin mt-0"></i></span>
                                                </span>
                                            </a>
                                        </div>

                                        <div class="form-group">
                                            <a href="JAvascript:void(0);" @click="signInMethodCall()"
                                                class="btn btn-submit btn-login">
                                                <span>
                                                    {{ $t('log-in','Login')}}
                                                    <i class="ml-2 fas fa-sign-in-alt"></i>
                                                </span>
                                                <span v-if="loading"> 
                                                    <span class="load-inner"><i class="fa fa-spinner fa-spin mt-0"></i></span>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    
                                    <template v-if="$siteSettings?.data?.business_type == 2">
                                        <div class="whatsapp-login get-whatsapp-btn" v-if="$siteSettings?.data?.social_link && $siteSettings?.data?.social_link?.whatsappno1">
                                            <h5>{{ $t('get-your-ready-made-id-from-whatsapp',"Get your ready-made ID from whatsapp")}}</h5>
                                            <button type="button" @click.prevent="openWhatsApp()">
                                                <img src="@/assets/images/whatsapp(1).webp" alt="">
                                                {{ $t('whatsapp-now',"WhatsApp Now")}}
                                            </button>
                                        </div>
                                    </template>

                                    <div class="other-login-option" v-if="$siteSettings?.data?.business_type == 2 && $siteSettings?.data?.social_link">
                                        <h3 v-if="$siteSettings?.data?.business_type == 2 && $siteSettings?.data?.social_link &&  ($siteSettings?.data?.social_link?.telegram_link || $siteSettings?.data?.social_link?.instagram_link || $siteSettings?.data?.social_link?.facebook_link)">{{ $t('or-login-with','Or Login With')}}</h3>
                                        <ul class="login-by-social-icon">
                                            <li v-if="$siteSettings?.data.social_link?.facebook_link">
                                                <a :href="$siteSettings?.data.social_link?.facebook_link" target="_blank">
                                                    <img src="@/assets/images/facebook.webp" alt="">
                                                </a>
                                            </li>
                                            <li v-if="$siteSettings?.data.social_link?.instagram_link">
                                                <a :href="$siteSettings?.data.social_link?.instagram_link" target="_blank">
                                                    <img src="@/assets/images/instagram.webp" alt="">
                                                </a>
                                            </li>
                                            <li v-if="$siteSettings?.data.social_link?.telegram_link">
                                                <a :href="$siteSettings?.data.social_link?.telegram_link" target="_blank">
                                                    <img src="@/assets/images/telegram.webp" alt="">
                                                </a>
                                            </li>
                                            <li v-if="$siteSettings?.data.social_link?.twitter_link">
                                                <a :href="$siteSettings?.data.social_link?.twitter_link" target="_blank">
                                                    <img src="@/assets/images/twitter.webp" alt="">
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <template v-if="$siteSettings?.data?.business_type == 2">
                                        <p class="whats-with-acc">{{ $t('dont-have-an-account',"Don’t Have An account?")}} &nbsp;
                                            <router-link v-if="isRootUrl" :to="{ name: 'SignUp' }" @click="refreshData">{{ $t('register','Register')}}</router-link>
                                            <a v-else data-bs-toggle="modal" @click="refreshData" data-bs-target="#signupModal">
                                                {{ $t('register','Register')}}
                                            </a>
                                        </p>
                                    </template>
                                    
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { AUTH_TOKEN } from '@/shared/constants/cookies-const';
import axios from 'axios';
import { setHeaders } from '@/shared/services/headers';
import validate from '../services/authValidation';
import commonAuth from '@/modules/authorization/services/commonAuth';

export default {
    name: "Login",
    extends: commonAuth,

    data() {
        return {
            form: {
                code: this.$siteSettings.data && this.$siteSettings.data.country_code ? this.$siteSettings.data.country_code : "91",
                mobileNo: "",
                userId: "",
                password: "",
                type: this.$siteSettings?.data?.business_type == 2 ? 1 : 2,
            },
            loading: false,
            demoloading: false,
            modal: null,
            validationErrors : null,
            init: false,
            showValidationError: false,
            loggedUserCheck: null,
            inputvalue: [
                {
                value: 100,
                },
                {
                value: 500,
                },
                {
                value: 1000,
                },
                {
                value: 2000,
                },
            ],

        };
    },
    computed: {
        isRootUrl() {
            return this.$route.path === '/login' || this.$route.path === '/forgot-password' || this.$route.path === '/register';
        }, 
        checkValidation() {
            const validationErrors = validate.areFieldsValid(
                'login', 
                this.form.type, 
                this.form.mobileNo, 
                this.form.userId, 
                this.form.password
            );
            if(this.init){
                return validationErrors;
            }
        }
    },
    mounted() {
        this.loggedUserCheck = localStorage.getItem("LoggedUser");
        if(localStorage.getItem('login_type') && this.$siteSettings?.data?.business_type == 2) {
            this.form.type = localStorage.getItem('login_type');
        }
    },
    methods: {    
        openWhatsApp() {
            window.open(`//wa.me/${this.$siteSettings?.data?.social_link.whatsappno1}`, '_blank');
        },
        demoUserLogin() {
            this.init = false;
            this.form.type = 1;
            this.form.userId = "demouser";
            this.form.password = "demopass";
            this.loginServiceCall('DEMO_LOGIN_API', 'demo')
        },
        signInMethodCall() {
            this.init = true;
            let id = this.getId();
            if (id == "" || this.form.password == "") {
                this.showValidationError = true;
            }
            else{    
                if(this.loginMethod == 'otp'){
                    if(this.isOtpApiCalled){
                        this.signInWithOtp()
                    }
                }
                else{
                    this.loginServiceCall('LOGIN_API', 'nondemo');
                }
            }
        },
        async loginServiceCall(url, type) {
            let id = this.getId();
            if(type == 'demo')
                this.demoloading = true;
            else
                this.loading = true;           
            let data = {
                "userid": id.toString(),
                "type": this.$siteSettings?.data?.business_type == 1 ? 2 : this.form.type,
                "password": this.form.password,
                "cncode": this.form.code,
            };
            this.$apiCall('post', url, data).then(response => {
                if(type == 'demo')
                    this.demoloading = false;
                else
                    this.loading = false; 
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.$errorToast(response.data.debug[0]);
                        }
                        else {
                            this.$successToast(response.data.message);
                            this.$helper.closeModal('loginModal')
                            let userData = response.data.data;
                            if(this.loggedUserCheck!=userData.userid){
                                this.$store.dispatch('setClickBetValue',this.inputvalue);
                                this.$store.dispatch('setIsClickBetOn',false);
                            }
                            this.$cookies.set(AUTH_TOKEN, userData.token);
                            this.$store.dispatch('setToken', `Bearer ${userData.token}`);
                            window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
                            axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
                            localStorage.setItem("LoggedUser",userData.userid)
                            localStorage.setItem('login_type', data.type)
                            if(type == 'demo'){
                                localStorage.setItem('isDemo', 'isDemo')
                            }
                            this.$store.dispatch('setSiteVersion', null);				
                            setHeaders();
                            this.setUserDataToStore(userData);
                            this.refreshData();
                            this.$router.push({ name: 'Home' });
                            setTimeout(()=>{
                                window.location.reload();
                            },500)
                        }
                    }
                }
            }).catch(error => {
                if(type == 'demo')
                    this.demoloading = false;
                else
                    this.loading = false; 
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        getId() {
            if (this.$siteSettings?.data?.business_type == 2) {
                return this.form.type == 1 ? this.form.mobileNo : this.form.userId;
            } else {
                this.form.type = 2;
                return this.form.userId;
            }
        },
        setUserDataToStore(userData) {
            let asciiCodes = null;
            for (let i = 0; i < userData.userid.length; i++) {
                asciiCodes += userData.userid.charCodeAt(i)
            }
            let user = {
                balance: userData.balance,
                currency: userData.currency,
                currency_slug: userData.currency_slug,
                last_login_at: userData.last_login_at,
                name: userData.name,
                rid: userData.rid,
                userid: userData.userid,
                exposure: userData.expl,
                available_credits: userData.available_credits,
                id: userData.id,
                exp: userData.exp,
                activeWallet: userData.actw,
                cpi:userData.cpi,
                notificationSubscribed:null,
                notificationUnsubscribed:null,
                asciiCodes: asciiCodes,

            }
            this.$store.dispatch('setUser', user);
            this.$store.dispatch('setChips', userData.chips);
            this.$store.dispatch('setEventManage', userData.lock_settings);
        },
        signInWithOtp() {
            let id = this.getId();
            this.loading = true; 
            let data = {
                mobile: id,
                countrycode: this.form.code,
                otp: this.form.password
            };
            this.$apiCall('post','LOGIN_WITH_OTP', data).then(response => {
                this.loading = false; 
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.showErrorModalFunc(response.data.debug[0]);
                        } else {
                        
                            this.$successToast(response.data.message);
                            let userData = response.data.data;
                            if(this.loggedUserCheck!=userData.userid){
                                this.$store.dispatch('setClickBetValue',this.inputvalue);
                            }
                            this.$cookies.set(AUTH_TOKEN, userData.token);
                            this.$store.dispatch('setToken', `Bearer ${userData.token}`);
                            window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
                            //for add on all APIs
                            axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
                            this.$store.dispatch('setSiteVersion', null);
                            setHeaders();
                            this.setUserDataToStore(userData);
                            this.$store.dispatch('setLoggedUser',userData.userid)
                            location.reload();
                            this.closeModal();
                        }
                    }
                }
            }).catch(error => {
                this.loading = false; 
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        chooseFormType(formType) {
            this.form.type !== formType && this.refreshData();
            this.form.type = formType;
            this.loginMethod = "password";

        },
        togglePasswordVisibility() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        },
    },
};
</script>

<style>form {
    margin-block-end: 1em;
}

.form-control.add::-webkit-inner-spin-button {
    display: none;
}</style>